/* eslint-disable max-len */
import { organizationusersList } from "./apiSlice";

const otpPreferenceList = organizationusersList.injectEndpoints({
    tagTypes: ['preference',],
    endpoints: (builder) => ({
        getOtpPreferenceList: builder.query({
            query: ({ username, user_type }) => ({
                url: `users/preference/${username}?user_type=${user_type}`,  // dynamically adding user_type in the URL
                method: 'GET',
            }),
        }),
        deleteOtpPreference: builder.mutation({
            query: (id) => ({
                url: `users/preference/${id}`,  // `id` is the actual value here
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'preference', id: arg }]
        }),
    }),
   
    overrideExisting: false
})


export const {
    useGetOtpPreferenceListQuery,
    useDeleteOtpPreferenceMutation
} = otpPreferenceList